import ProviderDetails from "../ProviderDetails";
import PlanLists from "../PlanLists";
import { ExternalContainer } from "../../../components/Account/reusables";
import { Header } from "../Header";

const AirtimePlan = () => {
  return (
    <div className="h-full  w-[full]  px-4 md:px-8 lg:px-[56px]">
      <ExternalContainer>
        <div>
          <Header />
          <div className="flex flex-col bp:flex-row items-start gap-6 lg:gap-12 mt-6">
            <ProviderDetails />
            <PlanLists productType="airtime" />
          </div>
        </div>
      </ExternalContainer>
    </div>
  );
};

export default AirtimePlan;
